export default {
  getHead: () => {
    return [{ name: '사업장명' }, { name: '점검구분' }, { name: '점검대상' }, { name: '점검일' }, { name: '점검장소' }, { name: '재해형태' }, { name: '작성자' }, { name: '작성일' }]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: return func.getContent(value).checkType // 점검구분
      case 2: return func.getContentStringList(func.getContent(value).typeTitleList) // 점검대상
      case 3: return func.getContent(value).stdInfo.점검일 // 점검일
      case 4: return func.getContent(value).stdInfo.점검장소 // 점검장소
      case 5: return func.getContent(value).stdInfo.재해형태 // 재해형태
      case 6: return func.getContent(value).stdInfo.writer_name // 작성자
      case 7: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType,  searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    if (nav.value.disasterType) returnData.push('content$body.stdInfo."재해형태"*[:default_disaster]')

    switch (nav.value.searchType) {
    case '사업장명': returnData.push('content$body.stdInfo.field_name*%[:default_skw]%'); break
    case '점검구분': returnData.push('content$body.checkType*%[:default_skw]%'); break
    case '점검대상': returnData.push('content$body.typeTitleList*%[:default_skw]%'); break
    case '점검일': returnData.push('content$body.stdInfo."점검일"*%[:default_skw]%'); break
    case '점검장소': returnData.push('content$body.stdInfo."점검장소"*%[:default_skw]%'); break
    case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }
    return returnData
  },
}
